import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface Ipayload {
  userid: string | null,
  fromdate: string,
  todate: string,
  sitecode: any,
  cafecode: any,
  //isallsite: boolean,
 // isallcafe: boolean,
  MenuPlanTypeId?: string;
}

const initialState: any = {
  projectionData: [],
  ismppublished:false,
  loading: false,
  error: null,
  cutoffdate: null,
  itemdisplayid: null,
  itemdisplayname: null
};
interface projectionData {
  dayparts: any;
  ismppublished: boolean;
  cutoffdate: string;
  itemdisplayid?: number;
  itemdisplayname?: string;
}

export const fetchItemMenuProjectionData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchItemMenuProjectionData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionItemWise/GetMenuProjectionRegularItemWise`, payload);
    return response.data.data
  }
);

export const ItemSaveMenuProjection = createAsyncThunk(
  'MenuProjection/ItemSaveMenuProjection',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionItemWise/SaveMenuProjectionItemWise`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionPlanCombo = createAsyncThunk(
  'MenuProjection/fetchInitiateMenuPlanCombo',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetProjectionMenuPlanCombo`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionnFoodProgram = createAsyncThunk(
  'MenuProjection/fetchMenuProjectionnFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetProjectionFoodProgramMenu`, payload);
    return response?.data?.data;
  }
);

export const saveMenuProjectionFoodProgram = createAsyncThunk(
  'MenuProjection/saveMenuProjectionFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/saveMenuProjectionFoodProgram`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionExportData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchMenuProjectionExportData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetMenuProjectionReport`, payload);
    return response.data.data
  }
);


const itemProjectionDataSlice = createSlice({
  name: 'ItemProjectionData',
  initialState,
  reducers: {
    updateProjectionData: (state, action) => {
      state.projectionData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemMenuProjectionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemMenuProjectionData.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = [...action.payload.dayparts];
        state.ismppublished = action.payload.ismppublished;
        state.cutoffdate = action.payload.cutoffdate;
        state.itemdisplayid = action.payload.itemdisplayid;
        state.itemdisplayname = action.payload.itemdisplayname;
      })
      .addCase(fetchItemMenuProjectionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(ItemSaveMenuProjection.fulfilled, (state) => {
        state.loading = false;
        // state.projectionData = action.payload.daypartmenulist;
        // state.cutoffdate = action.payload.cutoffdate
      })
      .addCase(ItemSaveMenuProjection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionPlanCombo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionPlanCombo.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
      })
      .addCase(fetchMenuProjectionPlanCombo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionnFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionnFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
      })
      .addCase(fetchMenuProjectionnFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveMenuProjectionFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveMenuProjectionFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
      })
      .addCase(saveMenuProjectionFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionExportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionExportData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchMenuProjectionExportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { updateProjectionData } = itemProjectionDataSlice.actions;
export default itemProjectionDataSlice.reducer;
